var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19064 13.1676C2.61268 13.1676 1.3335 11.9035 1.3335 10.3441C1.3335 8.78472 2.61268 7.52058 4.19064 7.52058C4.38005 7.52058 4.56516 7.5388 4.74427 7.57355M9.58746 5.85245C9.98464 5.71372 10.4121 5.63823 10.8573 5.63823C11.2938 5.63823 11.7131 5.71076 12.1036 5.84429M4.74427 7.57355C4.59154 7.16617 4.5081 6.72556 4.5081 6.26568C4.5081 4.18649 6.21368 2.50098 8.31762 2.50098C10.2774 2.50098 11.8916 3.96345 12.1036 5.84429M4.74427 7.57355C5.12055 7.64657 5.47035 7.79258 5.77794 7.99605M12.1036 5.84429C13.5955 6.35447 14.6668 7.75506 14.6668 9.40294C14.6668 11.2076 13.3819 12.7157 11.6668 13.0825",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 11.168V15.168M7.99984 11.168L9.33317 12.5013M7.99984 11.168L6.6665 12.5013",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReUploadIcon);
export default __webpack_public_path__ + "static/media/ReUploadIcon.a44d5abeac90cee264ef9c706bbc34eb.svg";
export { ForwardRef as ReactComponent };